import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';

import { Invencsalida } from "../invinterfaces/invenclispre";
import { Invdetlispre } from "../invinterfaces/invdetlispre";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvenclispreService {

  public enclispre: Invencsalida[] = []

  public _detlispre: Invdetlispre[];
  get detlispre(): Invdetlispre[] {
    return this._detlispre;
  }

  set detlispre(value: Invdetlispre[]) {
    this._detlispre = value;
  }
  private way: string;

  public configDecimales: any[];

  constructor(
    private confIniciales: ConfInicialesService,
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
  ) {
    this.way = sessionStorage.getItem('way');
  }


  validaartcod(arreglo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/7d559354adf64c00000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }

  validalistacod(arreglo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/3eaac9aaacb9d6000000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertaenclispre(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/12bf1dbeab6ebb00000000', {
      elementos: {
        p_ENCLISPRE_NUMERO: item.ENCLISPRE_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ENCLISPRE_FECHA: item.ENCLISPRE_FECHA,
        p_ENCLISPRE_CONCEPTO: item.ENCLISPRE_CONCEPTO,
        p_ENCLISPRE_ESTADO:item.ENCLISPRE_ESTADO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertadetlispre(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/12bf1dbeab6d7700000000', {
      elementos: {
        p_ENCLISPRE_NUMERO: item.ENCLISPRE_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ART_CODIGO: item.ART_CODIGO,
        p_DETLISPRE_CODIGO: item.DETLISPRE_CODIGO,
        p_DETLISPRE_PRECIO: item.DETLISPRE_PRECIO,
        p_DETLISPRE_DESCUENTO: item.DETLISPRE_DESCUENTO,
        p_DETLISPRE_PORCENTAJE: item.DETLISPRE_PORCENTAJE,
        p_DETLISPRE_COSTO: item.DETLISPRE_COSTO,
        p_linea: item.LINEA
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getenclispre(enclisnumero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/83baebb2b2e6780', {
      elementos: {
        p_ENCLISPRE_NUMERO: enclisnumero,
        p_COM_CODIGO: '01',

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetlispre(enclisnumero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/83bad776b2e6780', {
      elementos: {
        p_ENCLISPRE_NUMERO: enclisnumero,
        p_COM_CODIGO: '01',

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizalispre(enclisnumero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/a676b2e676e64800', {
      elementos: {
        p_ENCLISPRE_NUMERO: enclisnumero,
        p_COM_CODIGO: '01',
        p_usuidentificacion:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(enclisnumero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/178ded5b75eb2e0000', {
      elementos: {
        p_ENCLISPRE_NUMERO: enclisnumero,
        p_COM_CODIGO: '01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminadetregistro(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/inventario/listaprecios/7565695d4d776c000000', {
      elementos: {
        p_ENCLISPRE_NUMERO: item.ENCLISPRE_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ART_CODIGO: item.ART_CODIGO,
        p_DETLISPRE_CODIGO: item.DETLISPRE_CODIGO,
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  obtenerClave(straccion): Observable<any> {
    return this.http.post<any>(this.way + '/inventario/listaprecios/c2faebbb6caac00', {
      elementos: {
        accion: straccion
      }
    }, this.confIniciales.httpOptions());
  }
  obtenerConfig(campo, tabla): number {
    let numDecimales = 0;
    const decimales = this.configDecimales.find(element => element.NUMDEC_CAMPO === campo && element.NUMDEC_TIPDOC === tabla);
    if (decimales !== undefined) {
      numDecimales = decimales.NUMDEC_NUMDEC;
    } else {
      numDecimales = 2;
    }

    return numDecimales;
  }
}
